/* eslint-disable no-console */
import { API } from 'aws-amplify';
import { processApiUserData } from '../../utils/companyDataUtils';

// eslint-disable-next-line no-unused-vars
function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}
export function getEmployeesData(query:any)
{
	return API.get('userManagement', `/getEmployees${query}`, init);
}

export function getRelationsCount(query:any)
{
	return API.get('userManagement', `/manager${query}`, init);
}

export function updateEmployeeByCompany(body:any)
{
	const updatedUserBody = {
		...body,
		updateType : 'update',
		platform   : 'inlynk'
	};

	return API.put('ssoUserManagement', '/user', { body: updatedUserBody });
}
export function BPEEmployeeTagUpdate(body:any)
{
	return API.put('userManagement', '/employeeUpdate', { body });
}
export function RequestStatus(body:any)
{
	return API.put('connectionManagement', '/approveReject', { body });
}
export async function employeeById(query:string)
{
	const response = await API.get('ssoUserManagement', `/user/inlynk${query}`, init);

	return processApiUserData(response);
}
export function otherUser(queryStringParameters)
{
	return API.get('userManagement', '/otherUserProfile', { queryStringParameters });
}
export function getRelationCompany(query:string)
{
	return API.get('userManagement', `/relationManagerCompanies${query}`, init);
}
export function updateEmployeeAddress(body:any, query:any)
{
	return API.put('userManagement', `/employeeUpdate?type=${query}`, { body });
}
export function SendInvitation(body:any)
{
	return API.post('notification', '/sendLink', { body });
}
export function getNotificationCount()
{
	return API.get('notification', '/fetchNotifications', init);
}

export function getDepartmentDesgin()
{
	return API.get('departments', '/departmentDesignations', init);
}
export function getRelationByEmployee(query:any)
{
	return API.get('userManagement', `/getEmployeeRelations${query}`, init);
}
export function updateEmployeeName(body:any)
{
	return API.put('userManagement', '/updateName', { body });
}

export function getEmployeePermissions(employeeId:string, companyId:string)
{
	return API.get('revisedResources', `/configurations/${companyId}/employee-permissions/${employeeId}`, init);
}